import { Routes } from '@angular/router';
import { AboutComponent } from './pages/about/about.component';
import { AutoAperturaComponent } from './pages/auto-apertura/auto-apertura.component';
import { BeneficiosComponent } from './pages/beneficios/beneficios.component';
import { HomeComponent } from './pages/home/home.component';
import { AppunimarcComponent } from './pages/appunimarc/appunimarc.component';
import { MapaComponent } from './pages/map/mapa.component';
import { ProductsPageComponent } from './pages/products-page/products-page.component';
import { PreguntasFrecuentesComponent } from './pages/preguntas-frecuentes/preguntas-frecuentes.component';
import { InfoCorporativaSectionComponent} from './pages/info-corporativa/info-corporativa-section.component';
import { BasesComponent } from './components/legal/bases/bases.component';
import { GanadoresComponent } from './components/legal/ganadores/ganadores.component';
import { InformacionesComponent } from './pages/informaciones/informaciones.component';
import { EstadisticaLeyComponent } from './pages/estadisticas-ley/estadistica-ley.component';
import { DirectorioAdministracionComponent } from './pages/directorio-administracion/directorio-administracion';
import { EstatutosComponent } from './pages/estatutos/estatutos.component';
import { InfoEmpresaComponent } from './pages/info-empresa/info-empresa.component';
import { InvitaGanaComponent } from './pages/invita-gana/invita-gana.component';
import { InfoCorporativaComponent } from './components/legal/info-corporativa/info-corporativa.component';
import { RopComponent } from './components/legal/rop/rop.component';
import { EstadoFinancieroGrillaComponent } from './components/legal/estado-financiero-grilla/estado-financiero-grilla.component';
import { MemoriasGrillaComponent } from './components/legal/memorias-grilla/memorias-grilla.component';
import { TerminosycondicionesComponent } from './components/legal/terminosycondiciones/terminosycondiciones.component';
import { PortabilidadwebComponent } from './pages/portabilidadweb/portabilidadweb.component';
import { SolicitudPortabilidadComponent } from './pages/solicitud-portabilidad/solicitud-portabilidad.component';
import { PortabilidadmenuComponent } from './pages/portabilidadmenu/portabilidadmenu.component';
import { CortinaComponent } from './pages/cortina/cortina.component';
import { AsistenciaSaludComponent } from './pages/asistencia-salud/asistencia-salud.component';


export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'sobre-unipay',
    component: AboutComponent
  },
  {
    path: 'info-corporativa',
    component: InfoCorporativaSectionComponent
  },
  {
    path: 'directorio-administracion',
    component: InfoCorporativaComponent
  },
  {
    path: 'auto-apertura',
    component: AutoAperturaComponent
  },
  {
    path: 'beneficios',
    component: BeneficiosComponent
  },
    {
    path: 'solicitudcertificadoliquidaciondeuda',
    component: PortabilidadwebComponent
  },
  {
    path: 'solicitudportabilidadfinanciera',
    component: SolicitudPortabilidadComponent
  },
  {
    path: 'portabilidad-menu',
    component: PortabilidadmenuComponent
  },
  {
    path: 'mapa',
    component: MapaComponent
  },
  {
    path: 'preguntas-frecuentes',
    component: PreguntasFrecuentesComponent
  },
    {
    path: 'derechos-arcc',
    component: CortinaComponent
  },
  {
    path: 'productos',
    component: ProductsPageComponent
  },
  {
    path: 'bases-legales',
    component: BasesComponent
  },
  {
    path: 'ganadores-y-sorteos',
    component: GanadoresComponent
  },
  {
    path: 'informaciones',
    component: InformacionesComponent
  },
  {
    path: 'estadistica-ley',
    component: EstadisticaLeyComponent
  },
  {
    path: 'directorio',
    component: DirectorioAdministracionComponent
  },
  {
    path: 'estatutos',
    component: EstatutosComponent
  },
  {
    path: 'informacion-empresa',
    component: InfoEmpresaComponent
  },
  {
    path: 'invita-y-gana',
    component: InvitaGanaComponent
  },
   {
    path: 'asistencia-salud',
    component: AsistenciaSaludComponent
  },
  {
    path: 'rop',
    component: RopComponent
  },
  {
    path: 'terminosycondiciones',
    component: TerminosycondicionesComponent
  },
  {
    path: 'estados-financieros',
    component: EstadoFinancieroGrillaComponent
  },
  {
    path: 'memorias',
    component: MemoriasGrillaComponent
  },
   {
    path: 'appunimarc',
    component: AppunimarcComponent
  },

];
